module.exports = __webpack_public_path__ + "media/img/uploads/search-result-02-eb950df147b50643b23034cdd8535bfa.jpg";